import {
  ApiState,
  didError,
  didSucceed,
  getFetchSlice,
  hasStarted
} from "seneca-common/utils/apiStates";
import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

type State = ApiState;

// @ts-ignore
export const userStatsFetching: (state: State) => boolean = composeSelector(
  getFetchSlice,
  hasStarted
);

// @ts-ignore
export const userStatsFetchSucceeded: (state: State) => boolean =
  composeSelector(getFetchSlice, didSucceed);

// @ts-ignore
export const userStatsFetchErrored: (state: State) => boolean = composeSelector(
  getFetchSlice,
  didError
);

export function userStatsFetchFinished(state: State) {
  return userStatsFetchSucceeded(state) || userStatsFetchErrored(state);
}

export function userStatsNeedsFetching(state: State) {
  return !(userStatsFetchSucceeded(state) || userStatsFetching(state));
}
